import { createFileRoute } from "@tanstack/react-router";
import { useQuery } from "@tanstack/react-query";
import { reports } from "../lib/api";
import { money } from "../lib/utils";
import { useActiveBranch } from "../lib/session";

// Dashboard: consume dashboard_metrics (RPC real, probado en test 0013).
export const Route = createFileRoute("/")({ component: Dashboard });

function Dashboard() {
  const branch = useActiveBranch();
  const { data, isLoading, error } = useQuery({
    queryKey: ["dashboard", branch],
    queryFn: () => reports.dashboard(branch),
  });

  if (isLoading) return <Empty msg="Cargando KPIs…" />;
  if (error) return <Empty msg={`Error: ${(error as Error).message}`} />;

  const m = data!;
  return (
    <div>
      <h1 className="mb-4 text-2xl font-bold">Inicio</h1>
      <div className="grid grid-cols-2 gap-4 md:grid-cols-4">
        <Kpi label="Ventas hoy" value={money(m.sales_total)} sub={`${m.sales_count} tickets`} />
        <Kpi label="Margen bruto" value={money(m.gross_margin)} />
        <Kpi label="Bajo stock" value={String(m.low_stock_count)} accent={m.low_stock_count > 0} />
        <Kpi label="Fiado vigente" value={money(m.credit_outstanding)} />
      </div>
    </div>
  );
}

function Kpi({ label, value, sub, accent }: { label: string; value: string; sub?: string; accent?: boolean }) {
  return (
    <div className="rounded-xl border bg-white p-4 shadow-sm">
      <div className="text-xs text-grafito-400">{label}</div>
      <div className={`mt-1 text-2xl font-bold ${accent ? "text-brand" : ""}`}>{value}</div>
      {sub && <div className="text-xs text-grafito-400">{sub}</div>}
    </div>
  );
}
function Empty({ msg }: { msg: string }) {
  return <div className="rounded-xl border bg-white p-8 text-center text-grafito-400">{msg}</div>;
}
